import {
  client,
  ProgramReviewPayload,
  CloseProgramSchema,
  TargetStatusUpdate,
} from "../../../lib/api";

export const reviewProgram = async ({
  payload,
}: {
  payload: ProgramReviewPayload;
}) => {
  // 3. Dispatch the parent program post body
  return client.programs.postProgramsClose({
    id: payload.id,
    requestBody: {
      outcomeSummary: payload.outcomeSummary,
      targets: payload.targetsReached satisfies TargetStatusUpdate[],
    } satisfies CloseProgramSchema,
  });
};
